export const DZB_YOUNG_COMPANY_MONTHS_THRESHOLD = 36;
